import styled from 'styled-components';

export const StyledMightyFuSaleBadge = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  text-align: center;
  justify-content: center;
  z-index: 1;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);

  color: #19d1e6;
  font-size: 14px;
  font-weight: 900;
  text-transform: none;
  text-shadow: -1px -1px 0 #034051, 1px -1px 0 #034051, -1px 1px 0 #034051,
    1px 1px 0 #034051;
  width: 100%;
` as any;
